<template>
  <div class="outbox">
    <ul class="navlist">
      <li :style="{'color':navIndex==0?'#1c4cb4':'#333333'}">
        <span @click="tabNav(0)">手术刀</span>
        <ul class="childList"  v-show="navIndex==0&&isshow">
          <img src="../assets/img/icon.png" alt="" class="arrow">
          <li v-for="(item,index) in sharplist" v-if="index<4" @click="tabIndex(index)">
            <img :src="item.icon1" alt="">
          </li>
        </ul>
      </li>
      <li :style="{'color':navIndex==1?'#1c4cb4':'#333333'}">
        <span @click="tabNav(1)">缝合线</span>
        <ul class="childList" v-show="navIndex==1&&isshow">
          <img src="../assets/img/icon.png" alt="" class="arrow">
          <li v-for="(item,index) in sharplist" v-if="index==4" @click="tabIndex(index)">
            <img :src="item.icon1" alt="">
          </li>
        </ul>
      </li>
      <li :style="{'color':navIndex==2?'#1c4cb4':'#333333'}">
        <span @click="tabNav(2)">泪点塞栓</span>
        <ul class="childList" v-show="navIndex==2&&isshow">
          <img src="../assets/img/icon.png" alt="" class="arrow">
          <li v-for="(item,index) in sharplist" v-if="index==5" @click="tabIndex(index)" >
            <img :src="item.icon1" alt="">
          </li>
        </ul>
      </li>
    </ul>
    <img :src="sharplist[index].icon" alt="" class="icon" :style="{width:index==3?'5rem':'4rem'}">
    <div class="banner">
      <span class="banner_title">
          {{sharplist[index].title}}
        </span>
    </div>



    <!--切换内容-->
    <transition
    >

      <div class="view" v-if="index==0">
        <div class="content">
          <div class="video_img">
            <video src="../../static/video/video1.mp4" id="video1"
                   poster="../assets/img/sharpoint1.jpg"
                   x5-playsinline="true"
                   playsinline="true"
                   webkit-playsinline="true"
                   preload="auto"
                   loop controls ></video>
          </div>
          <div class="desc">
            Sharpoint眼科及显微外科手术刀具旨在满足各种眼科外科手术的需求，提供出色的精度和控制，从而实现精准的切口，出色的伤口结构和平滑、自密封的伤口。
          </div>

          <ul class="project_ul">
            <li @click="tolink('https://mp.weixin.qq.com/s/N5ohEiZXE0zMW7Q2ogGxiQ')">
              <img :src="sharplist[index].icon"  class="logo" alt="">
              <p class="product_text" :style="{color:sharplist[index].color}">经典眼科手术刀</p>
              <img src="../assets/img/1.png" class="product_img" alt="">
              <p>{{view}}</p>
            </li>
            <li @click="tolink('https://mp.weixin.qq.com/s/2J6DACS3LGhfFM6edwjIzQ')">
              <img :src="sharplist[index].icon" class="logo"  alt="">
              <p class="product_text" :style="{color:sharplist[index].color}">专家系列眼科手术刀</p>
              <img src="../assets/img/2.png" class="product_img" alt="">
              <p>{{view}}</p>
            </li>

          </ul>

        </div>

      </div>
      <div class="view" v-if="index==1">
        <div class="content">
          <div class="video_img">
            <video src="../../static/video/video2.mp4" id="video2"
                   poster="../assets/img/Stylus2.png"
                   x5-playsinline="true"
                   playsinline="true"
                   webkit-playsinline="true"
                   preload="auto"
                   loop controls ></video>
            <!--<img v-show="!isplayer" src="../assets/img/video1.png" alt="">-->
          </div>
          <div class="desc">
            Stylus精选眼科手术刀具旨在满足各种眼科外科手术的需求。它们旨在提供出色的精度和控制，从而实现精准的切口，出色的伤口结构和平滑，自密封的伤口。
          </div>

          <ul class="project_ul2">
            <li  @click="tolink('https://mp.weixin.qq.com/s/rBuL2mUBXvYVGoilIgdZtQ')">
              <div class="wrap_left">
                <img src="../assets/img/stylus.png" class="product_img" alt="">
              </div>
              <div class="wrap_right">
                <img :src="sharplist[index].icon"  class="logo" alt="">
                <p class="product_text" :style="{color:sharplist[index].color}">{{sharplist[index].title}}</p>
                <p>{{view}}</p>
              </div>



            </li>

          </ul>

        </div>

      </div>
      <div class="view" v-if="index==2">
        <div class="content">
          <div class="video_img">
            <video src="../../static/video/video3.mp4" id="video3"
                   poster="../assets/img/video3.png"
                   x5-playsinline="true"
                   playsinline="true"
                   webkit-playsinline="true"
                   preload="auto"
                   loop controls ></video>
            <!--<img v-show="!isplayer" src="../assets/img/video3.png" alt="">-->
          </div>
          <div class="desc">
            SharpGuard安全防护眼科手术刀提供Sharpoint优质刀片，安全防护型人体工程学手柄可以显著减少锐器对医护人员的伤害并完善保护刀头免受损害。多种规格可用，可以满足多种眼科外科手术的需求。
          </div>

          <ul class="project_ul2">
            <li @click="tolink('https://mp.weixin.qq.com/s/9sQzG3aFWGGxIVUcrhKYxw')">
              <div class="wrap_left">
                <img src="../assets/img/guard.png" class="product_img" alt="">
              </div>
              <div class="wrap_right">
                <img :src="sharplist[index].icon"  class="logo" alt="">
                <p class="product_text" :style="{color:sharplist[index].color}">{{sharplist[index].title}}</p>
                <p>{{view}}</p>
              </div>



            </li>

          </ul>

        </div>

      </div>
      <div class="view" v-if="index==3">
        <div class="content">
          <div class="video_img" style="display: none">
            <!--<video  id="video4"-->
                   <!--x5-playsinline="true"-->
                   <!--playsinline="true"-->
                   <!--webkit-playsinline="true"-->
                   <!--preload="auto"-->
                   <!--loop controls ></video>-->
            <!--<img v-show="!isplayer" src="../assets/img/video2.png" alt="">-->
          </div>
          <div class="desc">
            Unique 优科视技眼科手术刀，传承经典，革新工艺的第三代手术刀。
          </div>

          <ul class="project_ul2">
            <li @click="tolink('https://mp.weixin.qq.com/s/rIm7jvVMhwvO0IxCcM4A9Q')">
              <div class="wrap_left">
                <img src="../assets/img/edge.png" class="product_img" alt="">
              </div>
              <div class="wrap_right">
                <img :src="sharplist[index].icon"  class="logo" alt="">
                <p class="product_text" :style="{color:sharplist[index].color}">{{sharplist[index].title}}</p>
                <p>{{view}}</p>
              </div>



            </li>

          </ul>
          <!--<img src="../assets/img/expect.png" alt="">-->

        </div>

      </div>

      <div class="view" v-if="index==4">
        <div class="content">
          <div class="video_img">
            <video src="../../static/video/video5.mp4" id="video5"
                   poster="../assets/img/sharp.jpg"
                   x5-playsinline="true"
                   playsinline="true"
                   webkit-playsinline="true"
                   preload="auto"
                   loop controls ></video>
            <!--<img v-show="!isplayer" src="../assets/img/video2.png" alt="">-->
          </div>
          <div class="desc">
            Sharpoint眼科缝线采用了多种可吸收和不可吸收材料，并配有我们独特的UltraGlide针。专有的“提切”设计和防眩光四边钻石形态增强了组织缝合的效果。
          </div>

          <ul class="project_ul2">
            <li @click="tolink('https://mp.weixin.qq.com/s/f1GqaawJ1ngOtrHwkIFZBA')">
              <div class="wrap_left">
                <img src="../assets/img/point.png" class="product_img" alt="">
              </div>
              <div class="wrap_right">
                <img :src="sharplist[index].icon"  class="logo" alt="">
                <p class="product_text" :style="{color:sharplist[index].color}">{{sharplist[index].title}}</p>
                <p>{{view}}</p>
              </div>



            </li>

          </ul>

        </div>

      </div>
      <div class="view" v-if="index==5">
        <div class="content">
          <div class="video_img">
            <!--<video src="../../static/video/ultra.mp4"  id="ultra" controls v-show="isplayer"></video>-->
            <video src="../../static/video/video6.mp4"  id="video6" controls
                   poster="../assets/img/video4.jpg"
                   x5-playsinline="true"
                   playsinline="true"
                   webkit-playsinline="true"
                   preload="auto"
                   loop controls></video>
            <!--<div class="bg" v-show="!isplayer">-->
            <!--<img src="../assets/img/player.png" @click="bgPlay('ultra')" alt="">-->
            <!--</div>-->
            <!--<img v-show="!isplayer" src="../assets/img/video4.jpg" alt="">-->
          </div>
          <div class="desc">
            由柔软的医用级硅胶制成,采用单体式模具设计制作。泪点塞顶部盖子的扁平设计,几乎消除了异物感。盖子的柔韧性设计便于必要时移除泪点塞栓。泪点塞为单独包装,并预装在无菌的一次性植入器上。
          </div>
          <ul class="project_ul2">
            <li @click="tolink('https://mp.weixin.qq.com/s/jNJAlf_M-CdUkErAd5au9g')">
              <div class="wrap_left">
                <img src="../assets/img/ultra.png" class="product_img" alt="">
              </div>
              <div class="wrap_right">
                <img :src="sharplist[index].icon"  class="logo" alt="">
                <p class="product_text" :style="{color:sharplist[index].color}">{{sharplist[index].title}}</p>
                <p>{{view}}</p>
              </div>



            </li>

          </ul>

        </div>

      </div>
    </transition>





  </div>
</template>
<script>
  import sharp1 from '../assets/images/01.png'
  import sharp2 from '../assets/images/02.png'
  import sharp3 from '../assets/images/03.png'
  import sharp4 from '../assets/images/04.png'
  import sharp5 from '../assets/images/05.png'
  import sharp6 from '../assets/images/06.png'
  export default {
    data() {
      return {
        view: '查看产品 >',
        index: 0,
        isplayer:false,
        isshow:false,
        sharplist: [
          {
            icon: sharp1,
            color: '#1e459a',
            title: "专家系列眼科手术刀",
            type:0,
            icon1: sharp1,
          },{
            icon: sharp2,
            color: '#9e529b',
            title: "精选眼科手术刀",
            type: 0,
            icon1: sharp2,
          },{
            icon: sharp3,
            color: '#a99118',
            title: "安全防护眼科手术刀",
            type: 0,
            icon1: sharp3,
          },{
            icon: sharp4,
            color: '#10747a',
            title: "眼科手术刀",
            type: 0,
            icon1: sharp4,
          },{
            icon: sharp5,
            color: '#4d91ce',
            title: "眼科专用缝线",
            type: 1,
            icon1: sharp5,
          },{
            icon: sharp6,
            color: '#661958',
            title: "硅橡胶泪点塞栓",
            type: 2,
            icon1: sharp6,
          },
        ],
        navIndex: 0,
        navType: ['手术刀','缝合线','泪点塞栓']

      }
    },
    props: {},
    methods: {
      tolink(url){
        window.location.href = url;

      },
      tabNav(type){
        this.isshow = true;
        this.navIndex = type

      },
      bgPlay(id){
        let video = document.getElementById(id);
        this.isplayer = true;
        if(video.paused) {
          video.play()
        }else{
          video.pause()
        }


      },
      tabIndex(index){
        // this.isplayer = false;
        this.index = index;
        this.isshow = false;
        this.$router.push({
          query:{
            type :index
          }
        })
      }
    },
    computed: {},
    mounted() {
      if(this.$route.query.type){
        this.index = this.$route.query.type
      }


      if(this.index<4){
        this.navIndex = 0;
      }else if(this.index==4){
        this.navIndex = 1;

      }else if(this.index==5){
        this.navIndex = 2;

      }
    }
  }
</script>
<style scoped lang="scss">
  div,p,ul,li{
    box-sizing: border-box;
  }
  .childList{
    position: absolute;
    width: 2rem;
    left: 0.2rem;
    top: 0.72rem;
    width: 2rem;
    border-radius: 5px;
    border: 1.3px solid #dcdcdc;
    background: #FFFFFF;
    .arrow{
      position: absolute;
      top: -0.19rem;
      left: 42%;
      width: 0.32rem;
    }
    li{
      height: 0.68rem;
      border-bottom: 1px solid #dcdcdc;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 1.34rem;
      }
    }
    li:nth-last-of-type(1){
      border: none;
    }
  }
  .outbox{
    padding: 0.15rem 0.32rem 0.62rem;
  }
  .navlist{
    display: flex;
    /*margin-bottom: 1.34rem;*/
    margin-bottom: 0.5rem;

    >li{
      width: 2.46rem;
      font-size: 0.34rem;
      text-align: center;
      height: 0.6rem;
      line-height: 0.6rem;
      font-weight: bold;
      color: #333333;
      position: relative;
    }
    >li:nth-of-type(2){
      border-left: 1px solid #d2d2d2;
      border-right: 1px solid #d2d2d2;
    }
  }
  .icon{
    margin: 0 auto;
    display: block;
    width: 4rem;
  }
  .banner{
    width: 100%;
    height: 1.2rem;
    background-image:url("../assets/img/radius.png");
    background-size: 100% 100%;
    position: relative;
    font-size: 0.32rem;
    text-align: center;
    line-height: 1.2rem;
    color: #fefefe;
    margin-top: 1.1rem;
    margin-bottom: 0.3rem;
    display: none;
    .banner_title{
      margin: auto auto;
    }
    img{
      width: 1.2rem;
      display: inline-block;
      position: absolute;
      left: 0.5rem;
      top: 0.2rem;
    }
  }
  .container{
    font-size: 0.18rem;
    color: #666666;
    margin-bottom: 0.56rem;
    >div{
      display: flex;
    }
    .projecttype{
      width: 0.32rem;
      height: 0.91rem;
      color: #FFFFFF;
      background: #1e53a4;
      text-align: center;
      font-weight: 500;
      font-style:oblique;
    }
    ul{
      display: flex;
      flex-wrap: wrap;
      li{
        width: 1.51rem;
        border: 1px solid #dcdcdc;
        border-bottom: 6px solid #dcdcdc;
        margin-bottom: 0.18rem;
        text-align: center;
        margin-left: 0.13rem;
        img{
          height: 0.31rem;
          line-height: 0.42rem;
        }
        p{
          height: 0.43rem;
          border-top: 1px solid #dcdcdc;
          line-height: 0.43rem;
          font-style:oblique;
        }
      }
    }
  }
  .view{
    text-align: center;
  }
  .content{
    margin-top: 0.5rem;
    .desc{
      color: #666666;
      font-size: 0.24rem;
      margin-top: 0.5rem;
      text-align: left;
    }


  }
  .video_img{
    /*width: 6.68rem;*/
    /*height: 2.6rem;*/
    /*position: relative;*/
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    video{
      width: 100%;
      display: block;
      /*height: 100%;*/
      /*position: absolute;*/
      /*left: 0;*/
      /*right: 0;*/
      border-radius: 10px;
    }
    >img{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      border-radius: 8px;
      display: inline-block;
    }

  }
  .project_ul2{
    width: 100%;
    padding: 0.32rem 0.33rem 0.34rem;
    border: 1px solid #dcdcdc;
    margin-top: 0.5rem;
    border-radius: 8px;
    li{
      width: 100%;
      height: 100%;
      display: flex;
      .wrap_left{
        width: 3.14rem;
        height: 1.85rem;
        border: 1px solid #dcdcdc;
        margin-right: 0.55rem;
        flex-shrink: 0;
        border-radius: 4px;
        .product_img{
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
      }
      .wrap_right{
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .logo{
          width: 1.68rem;
        }

      }

    }
  }
  .project_ul{
    margin-top: 0.2rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    li{
      width: 3.34rem;
      border: 1px solid #dcdcdc;
      height: 2.81rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 8px;
      img{
        display: inline-block;
      }
      .logo{
        width: 1.3rem;
        margin-top: 0.18rem;
        margin-bottom: 0.12rem;
      }
      .product_img{
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
  .project_ul ,.project_ul2{
    .product_text{
      font-size: 0.24rem;
      font-style: normal;
    }
    p{
      color: #666666;
      font-size: 0.2rem;
      font-style: italic;
    }
  }


  .bg{
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.3);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    text-align: center;
    img{
      width: 0.83rem;
      height: 0.83rem;
      display: inline-block;
      margin-top: 0.89rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/index.vue